/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import http from './index';

let globalFlagForUserList = true;

export const healthCheck = () => http.get('/health-check');
export const postFeedInput = (params) =>
  http.post('/winflows_calculations', params);
export const postWinflowsSolveOrder = (params) =>
  http.post('/winflows_solve_order', params);
export const CIPCalculatorApi = (params) =>
  http.post('/cip_calculations', params);

export const VerifyEmail = (params) =>
  http.post('/verifyEmail', params);

export const getWinflowsFileList = (params1, params2) =>
  http.get(`/winflows_get_file_list?param1=${params1}&param2=${params2}`);
// export const getWinflowsFileContent = (params1, params2, params3) =>
//   http.get(`/winflows_get_winfile_content?param1=${params1}_${params2}&param2=${params1}&param3=${params3}`);

export const getWinflowsFileContent = (params1, params2, params3, param4 = '') => {
  if (param4 !== '') {
    return http.get(`/winflows_get_winfile_content?param1=${param4}/${params1}_${params2}&param2=${params1}&param3=${params3}`);
  }
  return http.get(`/winflows_get_winfile_content?param1=${params1}_${params2}&param2=${params1}&param3=${params3}`);
};

export const getWinflowsFileContent_folder = (folder, params1, params2, params3) =>
  http.get(`/winflows_get_winfile_content?param1=${folder}${params1}_${params2}&param2=${params1}&param3=${params3}`);
// http.get(`/winflows_get_winfile_content?param1=${folder}/${params1}_${params2}&param2=${params1}&param3=${params3}`);

export const getWinflowsFileContent_preconfigFile = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const getWinflowsFileContent_FlowsheetWizard = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const getWinflowsFileContent_units = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const saveWinflowsFileContent = (params1, params2, params3, params4) =>
  http.post(`/winflows_file_save?param1=${params1}&param2=${params2}&param3=${params3}`, params4);
export const WinflowsFileManagmentAPI = (params) =>
  http.post('/winfiles_files_managment', params);
export const getEDIDataOnChange = (params) =>
  http.post('/winflows_edi_calculations', params);
export const getArgoWordDoc = (params) =>
  http.post('/googleDocReport', params);
export const unitConvertion = () =>
  http.post('/unit_conversion?param1=100&param2=m3/hr&param3=m3/day');
export const defaultUnits = (params) => http.post('/default_units', params);
export const getFlowSheet = (params) => http.post('/flowsheet_selection', params);
export const dbTransaction = (params) => http.post('/db_transactions?param1=""', params);
export const roMachine = (params) => http.post('/db_transactions?param1=ROMachine', params);
export const getImagePath = (params) => http.post('/WinLambda1', params);
export const externalApprovedUser = (params) => http.get('/external_approvedUser', params);

export const download_spec_file = (params1) =>
  http.get(`/download-spec-file?param1=${params1}`);

// for Admin by Abhishek on 12-Jan-24
export const getAdminData = (params) => http.post('/winflows_db_update', params);
export const addAdminData = (params) => http.post('/winflows_db_update', params);
export const updateAdminData = (params) => http.post('/winflows_db_update', params);
export const deleteAdminData = (params) => http.post('/winflows_db_update', params);
export const storeDBLogData = (params)=> http.post('/store_db_log_data', params);
export const downloadFile = (params) => http.post('/winflows_csv_file_write', params, true);

export const downloadFiledoc = (params) => http.get('/googleDocReport', params, true);

export const deleteFile = (params) =>
  // Changed to read delete-file endpoint from env configuration.
  http.del(process.env.REACT_APP_DELETE_FILE_URL, params, true);
export const checkFileExists = (params1, params2, params3) =>
  http.get(`/checkFileExist?param1=${params1}&param2=${params2}&param3=${params3}`);

export const getUserListData = () => {
  if (globalFlagForUserList) {
    globalFlagForUserList = false;
    const UserListData = sessionStorage.getItem('UserListData');
    if (UserListData);
    else {
      // Changed to read live-list endpoint from env configuration.
      http.post(process.env.REACT_APP_LIVE_LIST_URL, {}, true).then((response) => {
        response.data.UserList.sort((a, b) => {
          return a.OEMAIL > b.OEMAIL ? 1 : -1;
        });
        sessionStorage.setItem('UserListData', JSON.stringify(response.data.UserList));
      });
    }
  }
};

export const getProjectWinflowsFileList = (params1, params2, page = 1, limit = 30, type = 'my_projects', path = '') => {
  let replacePath = path;
  let params = `param1=${params1}&param2=${params2}&param3=${page}&param4=${limit}&param5=${type}`;
  if (replacePath) {
    if (replacePath.indexOf('winfiles/') === 0) {
      replacePath = replacePath.replace('winfiles', 'project_files');
      // replacePath = replacePath.replace('winfiles', 'winfiles');
    } else {
      replacePath = replacePath.replace('winfiles', 'project_files');
      // replacePath = replacePath.replace('winfiles', 'winfiles');
    }
    params += `&param6=${replacePath}`;
    return http.get(`/winflows_get_project_file_list?${params}`);
  }
  return http.get(`/winflows_get_project_file_list?${params}`);
};
export const FetchGoogleSpredSheetData = async (param) => {
  const data = await http.post('/upwGoogleSheet', param);
  return data;
};

export const updateProjectInfoDictIsReadtoTrue = (params1, params2, params3, params4) =>
  http.post(`/winflows_project_file_save?param1=${params1}&param2=${params2}&param3=${params3}`, params4);

export const deleteWinAndProjectFile = (params1, params2, params3) =>
  http.post(`/delete_s3_files?param1=${params1}&param2=${params2}`, params3);

export const fileConversion = (params) => http.post('/file_conversion', params);
export const sign_up = (params) => http.post('/sign_up', params);
// export const userTracking = (params) => http.post('/usertracking', params);

export const logWinFileChange = (params) => http.post('/logWinFileChange', params);

export const readPreconfigFilesFromS3 = () => http.get('/read_preconfig_files_from_s3');
